/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index date-picker to autogenerate all the components and extensions
 * Used by "prepareDatePickers"
 */

import DatePicker from './date-picker/DatePicker'
export * from './date-picker/DatePicker'
export default DatePicker
